/**
 * Route paths for the app surface, in one place.
 *
 * The root is `/dashboard` because four flows already land there — login, quiz
 * submit, the extended-track flow and the email step. Swapping what renders at
 * that URL is safer than adding a new one and chasing every redirect.
 *
 * The previous editorial dashboard stays reachable at `LEGACY` so the two can be
 * compared, and so a rollback is a one-line route change rather than a revert.
 */
export const ROOT = '/dashboard';

export const R = {
    state: ROOT,
    dirs: `${ROOT}/directions`,
    dir: (code: string) => `${ROOT}/directions/${code}`,
    pats: `${ROOT}/patterns`,
    pattern: (code: string) => `${ROOT}/patterns/${code}`,
    ins: `${ROOT}/insights`,
    tasks: `${ROOT}/tasks`,
    task: (code: string) => `${ROOT}/tasks/${code}`,
    taskDay: (code: string) => `${ROOT}/tasks/${code}/day`,
    account: `${ROOT}/account`,
    legacy: `${ROOT}/legacy`,
} as const;

/** Quiz entry points, referenced from empty states and retake actions. */
export const QUIZ = {
    full: '/quiz/doyourstep-quiz',
    track: (code: string) => `/quiz-extended/doyourstep-quiz/${code}`,
} as const;
